<template>
  <div class="result-page">
    <div class="top-blue">
      <button type="button" class="back" aria-label="返回" @click="goHome">
        <span class="back-ic" />
      </button>
      <h1 class="top-title">支付结果</h1>
    </div>

    <main class="main">
      <div v-if="loadError" class="card card--error">
        <p>{{ loadError }}</p>
        <el-button type="primary" plain @click="fetchDetail">重新查询</el-button>
      </div>

      <div v-else-if="!detail" class="card">
        <p class="muted">加载中…</p>
      </div>

      <div v-else class="card">
        <div class="status-icon" :class="statusClass" />
        <h2 class="status-text">{{ statusText }}</h2>
        <ul class="meta">
          <li><span>订单号</span><b>{{ detail.reference }}</b></li>
          <li><span>金额</span><b>¥{{ detail.amountYuan }} {{ detail.currency }}</b></li>
          <li><span>支付方式</span><b>{{ payTypeLabel }}</b></li>
          <li v-if="detail.transactionId">
            <span>交易号</span><b>{{ detail.transactionId }}</b></li>
          <li v-if="detail.updateTime">
            <span>更新时间</span><b>{{ detail.updateTime }}</b></li>
        </ul>
        <p v-if="detail.status === 'pending'" class="hint">
          支付结果同步可能有延迟，将自动刷新；您也可手动刷新页面。
        </p>
        <div class="actions">
          <el-button type="primary" @click="goHome">返回支付</el-button>
          <el-button v-if="detail.status === 'pending'" plain @click="fetchDetail">
            刷新
          </el-button>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
export default {
  name: "PayResult",
  data() {
    return {
      detail: null,
      loadError: "",
      pollTimer: null,
    };
  },
  computed: {
    statusText() {
      if (!this.detail) return "";
      const m = {
        success: "支付成功",
        failure: "支付失败",
        failed: "支付失败",
        closed: "交易已关闭",
        pending: "处理中",
      };
      const key = (this.detail.status || "").toLowerCase();
      return m[key] || this.detail.status;
    },
    statusClass() {
      if (!this.detail) return "";
      const s = (this.detail.status || "").toLowerCase();
      if (s === "success") return "ok";
      if (s === "failure" || s === "failed" || s === "closed") return "fail";
      return "pending";
    },
    payTypeLabel() {
      if (!this.detail) return "";
      const m = {
        wechatpay: "微信",
        alipay: "支付宝",
        unionpay: "银联",
      };
      return m[this.detail.vendor] || this.detail.vendor;
    },
  },
  mounted() {
    this.fetchDetail();
    this.pollTimer = setInterval(() => {
      if (this.detail && this.detail.status === "pending") {
        this.fetchDetail();
      }
    }, 2500);
  },
  beforeDestroy() {
    if (this.pollTimer) {
      clearInterval(this.pollTimer);
    }
  },
  methods: {
    orderId() {
      const q = this.$route.query || {};
      const raw = q.id != null ? q.id : this.$route.params.id;
      const n = parseInt(String(raw), 10);
      return Number.isFinite(n) && n > 0 ? n : null;
    },
    fetchDetail() {
      const id = this.orderId();
      if (!id) {
        this.loadError = "缺少订单 id，请从支付页重新发起支付。";
        this.detail = null;
        return;
      }
      this.loadError = "";
      this.axios
        .get(`/nihaopay/securePay/detail/${id}`)
        .then((res) => {
          if (res.data.code !== 200) {
            this.loadError = res.data.message || "查询失败";
            this.detail = null;
            return;
          }
          this.detail = res.data.data || null;
        })
        .catch(() => {
          this.loadError = "网络异常，请稍后重试";
          this.detail = null;
        });
    },
    goHome() {
      this.$router.replace({ path: "/" });
    },
  },
};
</script>

<style lang="scss" scoped>
$blue: #1161ba;
$page-bg: #f5f6f7;

.result-page {
  min-height: 100vh;
  max-width: 390px;
  margin: 0 auto;
  background: $page-bg;
  font-family: "PingFang SC", "Microsoft YaHei", -apple-system, sans-serif;
  padding-bottom: calc(24px + env(safe-area-inset-bottom));
}

.top-blue {
  height: 100px;
  background: $blue;
  padding: calc(12px + env(safe-area-inset-top)) 12px 0;
  position: relative;
  box-sizing: border-box;
}

.back {
  position: absolute;
  left: 15px;
  top: calc(12px + env(safe-area-inset-top));
  width: 36px;
  height: 36px;
  border: none;
  background: transparent;
  padding: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.back-ic {
  width: 10px;
  height: 10px;
  border-left: 2px solid #fff;
  border-bottom: 2px solid #fff;
  transform: rotate(45deg);
  margin-left: 4px;
}

.top-title {
  margin: 0;
  padding-top: 8px;
  text-align: center;
  font-size: 16px;
  font-weight: 500;
  color: #fff;
}

.main {
  padding: 20px 16px;
}

.card {
  background: #fff;
  border-radius: 16px;
  padding: 28px 20px;
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.05);
  text-align: center;
}

.card--error {
  text-align: left;
}

.muted {
  color: #8a93a3;
  margin: 0;
}

.status-icon {
  width: 56px;
  height: 56px;
  margin: 0 auto 16px;
  border-radius: 50%;
  &.ok {
    background: #e8f8e8;
    border: 3px solid #43c93e;
  }
  &.fail {
    background: #fdecec;
    border: 3px solid #e54545;
  }
  &.pending {
    background: #eef6ff;
    border: 3px solid $blue;
  }
}

.status-text {
  margin: 0 0 20px;
  font-size: 20px;
  font-weight: 600;
  color: #2c3e50;
}

.meta {
  list-style: none;
  padding: 0;
  margin: 0 0 20px;
  text-align: left;

  li {
    display: flex;
    justify-content: space-between;
    gap: 12px;
    padding: 10px 0;
    border-bottom: 1px solid #f0f2f5;
    font-size: 14px;

    span {
      color: #7a8699;
      flex-shrink: 0;
    }

    b {
      font-weight: 500;
      color: #2c3e50;
      text-align: right;
      word-break: break-all;
    }
  }
}

.hint {
  font-size: 12px;
  color: #8a93a3;
  line-height: 1.5;
  margin: 0 0 16px;
  text-align: left;
}

.actions {
  display: flex;
  gap: 12px;
  justify-content: center;
  flex-wrap: wrap;
}
</style>
